import styled from 'styled-components';

export const PositionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  padding: 5px 15px 10px;

  .sub-tab {
    flex-shrink: 0;
  }

  .sub-tab > .shell-tabs-nav {
    border-bottom: 1px solid ${(props) => props.theme.border.medium};
  }

  &:has(.period-gas-day-field) {
    padding-inline: 18px;

    .sub-tab > .shell-tabs-nav {
      border-bottom: 0;
    }
  }

  /* Fill the remaining height so only the table scrolls, not the page. */
  .content {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    padding: 12px 0 0;
  }
`;
